import { render, staticRenderFns } from "./GoscriptsPage.vue?vue&type=template&id=930477aa"
import script from "./GoscriptsPage.vue?vue&type=script&lang=js"
export * from "./GoscriptsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports